import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput/';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { FormInputViewOnly } from 'elements/Inputs/FormInput/FormInputViewOnly';
import { StyleDropdown } from '../AsFoundTestTableSection/AsFoundTestSection.styled';
import { SelectFailToleranceAlarmSection } from './FailToleranceAlarm.data';
import { InputAutogrow } from 'elements/Inputs/FormInput/InputAutogrow/InputAutogrow';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const FailToleranceAlarmSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    const formAutoGrow = (field) => field.isAutoGrow ? (
        <InputAutogrow
            id={field.key}
            name={field.key}
            value={field.value}
            maxLength={field.maxLength}
            handleChange={changeHandler}
            inputWidth={field.inputWidth}
            width={field.labelWidth}
            label={field.label}
            marginBottom={field.marginBottom}
            marginLeft={field.marginLeft}
            direction={field.direction}
            marginRight={field.marginRight}
            padding={field.padding}
            isCalculatedNew={field.isCalculatedNew}
            inputMarginTop={field.inputMarginTop}
            readOnly={isFormReadOnly}
            isDisabled={field.readOnly}
            isRequired={field.isRequired}
            textAlign={field.textAlign}
            marginTop={field.marginTop}
        />
    ) : (
        <FormInput
            id={field.key}
            name={field.key}
            label={field.label}
            value={field.value}
            isRequired={field.isRequired}
            isCalculated={field.isCalculated}
            isCalculatedNew={field.isCalculatedNew}
            isDisabled={field.isDisabled}
            readOnly={field.readOnly || isFormReadOnly}
            handleChange={changeHandler}
            direction={field.direction}
            textAlign={field.textAlign}
            type={field.type}
            padding={field.padding}
            width={field.width}
            labelWidth={field.labelWidth}
            marginLeft={field.marginLeft}
            maxLength={field.maxLength}
            marginRight={field.marginRight}
            fontSize={field.fontSize}
            marginBottom={field.marginBottom}
            marginTop={field.marginTop}
            borderRight={field.borderRight}
            height={field.height}
            userRole={userRole}
            borderTop={field.borderTop}
            borderLeft={field.borderLeft}
            isLabelNew={field.isLabelNew}
            inputMarginRight={field.inputMarginRight}
            isLabelBold={field.isLabelBold}
            fontWeight={field.fontWeight}
            hasDPSError={field.hasDPSError}
            hasDPSNotNullError={field.hasDPSNotNullError}
        />
    );
    const formInputView = (field) => field.isInfo ? (
        <FormInputViewOnly
            id={field.key}
            name={field.key}
            label={field.label}
            value={field.value}
            fontStyle={field.fontStyle}
            width={field.width}
            height={field.height}
            wordBreak={field.wordBreak}
            labelWidth={field.labelWidth}
            noWrap={field.noWrap}
            field={field.padding}
            padding={field.padding}
            marginBottom={field.marginBottom}
            textAlign={field.textAlign}
            valueMarginTop={field.valueMarginTop}
        />
    ) : formAutoGrow(field);
    const formDropdownInput = (field) => field.isDropdown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly || field.readOnly}
                marginLeft={field.marginLeft}
                marginTop={field.marginTop}
                borderTop={field.borderTop}
                inputTextAlign={field.inputTextAlign}
                marginBottom={field.marginBottom}
                borderBottom={field.borderBottom}
                height={field.height}
                paddingTop={field.paddingTop}
            />
        </StyleDropdown>
    ) : formInputView(field);
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                SelectFailToleranceAlarmSection(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            fontWeight={field.fontWeight}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            fontSize={field.fontSize}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : formDropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Home, Forms }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FailToleranceAlarmSection);

FailToleranceAlarmSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
